module.exports = __webpack_public_path__ + "static/media/dongyangmirae.b235570d.png";